// extracted by mini-css-extract-plugin
module.exports = {"addCollaborator":"AddUserWorkflowCollaboratorForm_addCollaborator__1qw3I"};